const RESTING = 5;

/** The takes a closed pile shows, left to right: the newest five, or the shown one in place of the oldest when it is older than them. */
export function restingTakes(count: number, active: number): number[] {
  const atRest = Array.from({ length: count }, (_, index) => index).slice(-RESTING);
  if (!atRest.includes(active)) atRest[0] = active;
  return atRest;
}
